export enum EnumPaymentMethod {
    Boleto = 'Boleto',
    CreditCard = 'Cartão de Crédito',
    Money = 'Dinheiro',
    Pix = 'PIX',
    BankTransfer = 'Transferência Bancária',
}

export const paymentMethods = Object.entries(EnumPaymentMethod).map(([key, value]) => ({ value: key, label: value }));
